import { ReturnAddressRouteService } from 'common/data';
import { BaseService } from 'core/services';
import { findParams } from 'core/utils';

class ReturnAddressService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new ReturnAddressRouteService());
	}

	find(filter) {
		var url = this.routeService.find(filter);
		return this.apiClient.post(url, findParams(filter));
	}

	remove(id) {
		var url = this.routeService.delete(id);
		return this.apiClient.delete(url + id);
	}
}

export default ReturnAddressService;



// WEBPACK FOOTER //
// ./src/common/data/services/ReturnAddressService.js